import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  Button,
  Stack,
  Typography,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const EditingItem = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  margin: theme.spacing(0, 0, 4, 0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

// eslint-disable-next-line
const BaseFieldEditor = ({
  open,
  onSave,
  children,
  title,
  loading,
  column,
  editing,
  currentlyEditing,
  setCurrentlyEditing,
  setCurrentEditor,
  actions,
}) => {
  if (!editing || editing.length <= 0) return null;
  const handleClose = () => {
    const action = actions.find((a) => a.id === column.action);
    action.doClose({ currentlyEditing, setCurrentlyEditing, column, setCurrentEditor });
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <EditingItem variant="outlined">
          <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
            <Typography variant="subtitle1" component="label" htmlFor="myField">
              Current Value:
            </Typography>

            <List
              style={{ flexGrow: 1, maxHeight: '33vh', overflowY: 'auto', overflowX: 'hidden' }}
            >
              {editing.map((item, index) => (
                // eslint-disable-next-line
                <ListItem key={index}>{column.render(item)}</ListItem>
              ))}
            </List>
          </Stack>
        </EditingItem>
        {children}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button variant="contained" onClick={handleClose} color="error" disabled={loading}>
          Close
        </Button>
        <Button variant="contained" onClick={onSave} color="success" disabled={loading}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BaseFieldEditor;
